var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.display
    ? _c("div", { staticClass: "property-text" }, [
        _c("div", {
          staticClass: "property-text__icon",
          class: _vm.icon,
          attrs: { title: _vm.readableName }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "property-text__input",
            class: { "property-text__input--readonly": _vm.isReadOnly }
          },
          [
            !_vm.isReadOnly
              ? _c("textarea", {
                  directives: [
                    {
                      name: "autosize",
                      rawName: "v-autosize",
                      value: true,
                      expression: "true"
                    }
                  ],
                  attrs: {
                    placeholder: _vm.placeholder,
                    rows: _vm.rows,
                    title: _vm.readableName
                  },
                  domProps: { value: _vm.value },
                  on: {
                    input: function($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.changeValue($event)
                    }
                  }
                })
              : _c("div", {
                  directives: [
                    {
                      name: "linkify",
                      rawName: "v-linkify",
                      value: _vm.value,
                      expression: "value"
                    }
                  ]
                })
          ]
        ),
        _vm._v(" "),
        _vm.hasInfo
          ? _c("div", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.info,
                  expression: "info"
                }
              ],
              staticClass: "property-text__info icon-details"
            })
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }